var map = {
	"./become": 78783,
	"./become.jpg": 78783,
	"./bottom": 18609,
	"./bottom.jpg": 18609,
	"./design": 36862,
	"./design.jpg": 36862,
	"./gallery-builder": 86770,
	"./gallery-builder.png": 86770,
	"./icon-1": 22934,
	"./icon-1.svg": 22934,
	"./icon-2": 11157,
	"./icon-2.svg": 11157,
	"./icon-3": 38548,
	"./icon-3.svg": 38548,
	"./icon-4": 48315,
	"./icon-4.svg": 48315,
	"./top": 15195,
	"./top.jpg": 15195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75181;